import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid, Typography } from "@mui/material";
import "./ImageConfigurator.scss";
import VerticalLinearStepper from "../../components/common/Stepper";
import HorizontalLinearStepper from "../../components/HorizontalStepper";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import ImageConfiguratorList from "../../components/ImageConfiguratorModule/ImageConfiguratorList";
import ImageConfiguratorForm from "../../components/ImageConfiguratorModule/CreateImageConfiguartor/index";
import Button from "../../components/common/Button";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  ImageConfigList,
  ImageByIdData,
  TestImage,
  ConfirmImage,
} from "../../redux/features/ImageConfigurator";
import { useLocation } from "react-router-dom";
import { RegionList } from "../../redux/TrainingCenter";
import Dropdown from "../../components/common/Dropdown";
import {
  imageSelectedData,
  cloudType,
} from "../../redux/features/ImageConfigReducer";
import { imageFormFilled } from "../../redux/features/ImageConfigReducer";
import { stateAction } from "../../redux/features/ImageConfigReducer";
import Cookies from "universal-cookie";
import MultiLine_Spinner from "../../components/multiline_spinner/Multiline_spinner";
import { Stack } from "@mui/system";
import ToolTip from "../../components/common/Tooltip";
import Info from "../../Images/yellow_info_icon.svg";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API } from "../../globals/constants";
import BreadCrumb from "../../components/BreadCrumb";
import { FOMRS, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";

function ImageConfigurator() {
  const navigate = useNavigate();
  const [imageDetails, setImageDetails] = useState([]);
  const [steps, setsteps] = useState([
    {
      label: "Step1",
      description: "Select Base Image",
    },
    {
      label: "Step2",
      description: "Image Details",
    },
    {
      label: "Step3",
      description: "Status",
    },
  ]);
  const [regionData, setRegionData] = useState([]);
  const [regionSelectedId, setRegionSelectedId] = useState("");
  const [image, setImage] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [count, setCount] = useState(0);
  const [windowSize, setWindowSize] = React.useState("");
  const [backState, setBackState] = useState(false);
  const dispatch = useDispatch();
  const { state } = useLocation();
  // const { loginResponse, loading, error } = useSelector((state) => {
  //   return state.login;
  // });
  const cookies = new Cookies();
  // const loginResponse = cookies.get("loginData");
  const { email_id, token, role_code, name, studio_id, id } =
    cookies.get("loginData");
  useEffect(() => {
    console.log("window", window.location.pathname);

    if (window.location.pathname === "/admin/imageconfigurator") {
      dispatch(imageSelectedData(""));
      dispatch(imageFormFilled(""));
      dispatch(cloudType(""));
    }
  }, [window.location.pathname]);
  const ImageListingResponse = useSelector((state) => {
    return state?.image_config_list;
  });
  const selectedSessionOption = useSelector((state) => {
    return state?.ImageDetails?.cloudType;
  });
  const region = useSelector((state) => {
    console.log("state checked", state);
    return state.region?.regionData?.data?.data?.rows;
  });
  const image_data = useSelector((state) => {
    return state?.ImageByIdData;
  });
  useEffect(() => {
    getRegion();
  }, [region]);
  useEffect(() => {
    getimageList();
  }, [ImageListingResponse?.ImageListingResponse]);
  useEffect(() => {
    getImage();
  }, [image_data?.ImageByIdData]);
  const getImage = () => {
    if (image_data?.loading === true) {
    } else {
      let data = image_data?.ImageByIdData?.data?.data;
      dispatch(imageSelectedData(data));
      dispatch(imageFormFilled(data));
      dispatch(
        cloudType({
          sessionType:
            data?.cloud_provider === "aws" ? "training" : "longtermsession",
        })
      );
      setImage(data);
    }
  };
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleChange = (selected) => {
    setRegionSelectedId(selected);
  };
  const handleBack = async () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    await setBackState(true);
  };
  const handleTest = async () => {
    if (regionSelectedId !== "") {
      setIsloading(true);
      const bodyParam = {
        arn: state.arn_id,
        createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
        region_code: regionSelectedId?.value,
      };
      // dispatch(TestImage({ token, bodyParam }));
      const response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.TEST_IMAGE
        }`,
        {},
        {},
        bodyParam
      );
      if (response.status === 200) {
        setCount(1);
        setIsloading(false);
        toast.success(`Please wait for your credentials by e-mail`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      } else {
        setIsloading(false);
        setCount(0);
        toast.error(`${response.err.data.msg1} `, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      }
    } else {
      toast.error(
        `Please select region from the dropdown in which you want to test`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
    }
  };
  const handleConfirm = async (cloudType) => {
    console.log("state?.cloud_typejh", cloudType);
    setIsloading(true);
    const bodyParam = {
      arn: state?.arn_id,
      created_by: id,
      studio_id: studio_id,
      ami_name: state?.ami_name,
      is_accept: true,
      isFail: false,
      cloud_type: cloudType,
    };
    const response = await api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.CONFIRM_IMAGE
      }`,
      {},
      {},
      bodyParam
    );
    console.log("check response---", bodyParam);
    if (response.status === 200) {
      setIsloading(false);
      navigate(APP_ROUTES.ROUTE_ROOT, {
        state: {},
      });
      toast.success(
        `AMI created successfully and you can create session using this AMI`,
        {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        }
      );
    } else {
      setIsloading(false);
    }
  };
  const getimageList = async () => {
    setIsloading(false);
    if (ImageListingResponse?.loading === false) {
      if (ImageListingResponse?.ImageListingResponse?.status === 200) {
        setIsloading(false);
        console.log(
          "ImageListingResponse====",
          ImageListingResponse?.ImageListingResponse?.data?.data?.new_ami
        );
        let data =
          ImageListingResponse?.ImageListingResponse?.data?.data?.new_ami.map(
            (item) => {
              let tool_data = item?.tools?.map((val, index) => {
                return `${index + 1}.${val.tool_name}`;
              });
              let tool_value = tool_data.toString();
              let project_data = item?.project
                ? item?.project.map((val, index) => {
                    return `${index + 1}.${val.project_name}`;
                  })
                : "";
              let project_value = project_data ? project_data.toString() : "";
              let project_description = project_value.replaceAll(",", "\n");
              let description = tool_value.replaceAll(",", "\n");
              console.log("exzxzc", description);
              return {
                ami: item.ami,
                tools: item.tools,
                description: description,
                project_description: project_description,
              };
            }
          );
        console.log("check the label data =====", data);
        await setImageDetails(data);
      }
    } else {
      setIsloading(false);
    }
  };
  const getRegion = () => {
    const regionData = region?.map((item) => {
      return {
        id: item.id,
        value: item.code,
        label: item.region_name,
      };
    });
    setRegionData(regionData);
  };
  const handleStateChange = () => {
    setBackState(true);
  };
  useEffect(() => {}, [imageDetails]);
  useEffect(() => {
    const params = {
      createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
    };
    console.log("state?.action=====", state?.action, state?.step);
    if (state?.action === "verify") {
      let params = {
        is_active: true,
        cloud_type: "AWS",
      };
      setActiveStep(state?.step);
      dispatch(RegionList({ token, params }));
    } else if (state?.action === "edit" || state?.action === "retry") {
      let params = {
        arn: state?.arn_id,
        createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
      };
      setActiveStep(state?.step);
      dispatch(ImageByIdData({ params }));
    } else if (state?.cloud_type === "GCP") {
      setActiveStep(2);
    } else {
      setActiveStep(0);
    }
    dispatch(stateAction({ action: state?.action }));
    // dispatch(ImageConfigList({ params }));
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setWindowSize(window.innerWidth);
    }, 2000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    console.log("window", window.location.pathname);

    if (window.location.pathname === "/admin/imageconfigurator") {
      dispatch(imageSelectedData(""));
      dispatch(imageFormFilled(""));
      dispatch(cloudType(""));
    }
  }, [window.location.pathname]);
  const renderSteps = () => {
    if (activeStep === 0) {
      return (
        <ImageConfiguratorList
          data={imageDetails}
          handleNext={handleNext}
          backState={backState}
          handleStateChange={() => handleStateChange()}
        />
      );
    } else if (activeStep === 1) {
      return (
        <ImageConfiguratorForm
          handleNext={handleNext}
          handleBack={handleBack}
          selectedData={image}
          ImageData={imageDetails}
        />
      );
    } else if (activeStep === 2) {
      return (
        <Grid conatiner spacing={2} className="Step3">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {state?.cloud_type === "GCP" ? (
              <Typography className="StatusMsg">
                You have successfully created your image, click on the
                confirmation button and create the training session with this
                image.
              </Typography>
            ) : state?.action === "verify" ? (
              <Typography className="StatusMsg">
                Your AMI has been created, Please select region and start
                testing.You will receive e-mail for VM login credentials for
                testing
              </Typography>
            ) : (
              <Typography className="StatusMsg">
                You have completed the steps for creating the VM image, Please
                wait until the creation of VM image. After the VM image is
                created, you can check the notification on the dashboard. Please
                be patient as the VM image creation process time takes up to 3
                hrs.
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="TopMargin"
          >
            {state?.cloud_type === "GCP" ? (
              ""
            ) : state?.action === "verify" ? (
              <div>
                <Grid container spacing={1} className="top-margin-test">
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <Dropdown
                      placeholder="Select Region"
                      options={regionData}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={regionSelectedId}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <Button
                      value="test"
                      onClick={handleTest}
                      role="primary"
                      disabled={count === 1 || isLoading}
                    />
                  </Grid>
                </Grid>
                {/* <div className="flexDisplay"></div> */}
                <Typography className="TopMargin content-adjust-test">
                  OR
                </Typography>
                <Typography className="StatusMsg TopMargin">
                  You can directly confirm your AMI without testing. Please
                  click on the confirmation button below once you have clicked
                  on the confirmation button then you will not be able to test
                  AMI again it will be added to AMI list
                </Typography>
              </div>
            ) : (
              ""
            )}
          </Grid>

          <Grid conatiner>
            <div
              className={
                state?.action === "verify"
                  ? "assignedImagebtm_verify"
                  : "assignedImagebtm"
              }
            ></div>
            <div className="flexDisplay">
              {/* {state?.action === "verify" ? (
                <Button value="test" onClick={handleTest} role="primary" />
              ) : (
                ""
              )} */}
              {/* <Button
                value="Resend Email"
                onClick={handleBack}
                role="default"
              /> */}
              <Button
                value="Confirm"
                role="primary"
                onClick={() => handleConfirm(state?.cloud_type)}
                disabled={
                  state?.action === "verify" || state?.cloud_type === "GCP"
                    ? false
                    : true
                }
              />
            </div>
          </Grid>
        </Grid>
      );
    }
  };
  return (
    <>
      <Box>
        <Grid container spacing={1}>
          {console.log("staterrrrrr--", state)}
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
            <Typography className="image_heading">
              {/* <BreadCrumb value=" Image Configurator" /> */}
              <span className="larger_f_bold">Image Configurator</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
            <Stack direction="row">
              <a
                href="https://docs.google.com/document/d/1ZPpkvHKCd27pv92yKgdMJWgrc5FAB1xfJbR_nPZc-u0/edit "
                target="_blank"
                className="documentation"
              >
                <Typography
                  variant="h6"
                  className="dashboard_heading documentation_link"
                >
                  Documentation
                </Typography>
              </a>

              <ToolTip
                title={"Click to download user manual"}
                placement="right"
                arrow={true}
                content={<img src={Info} className="Info_Img_config" />}
              ></ToolTip>
            </Stack>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div
              className={
                window.innerWidth > 768
                  ? "step-cont-image LeftPadding"
                  : "step-cont-smallscreen"
              }
            >
              {/* {window.innerWidth < 768 ? (
                <HorizontalLinearStepper steps={steps} activeStep={activeStep} />
              ) : (
                <VerticalLinearStepper steps={steps} activeStep={activeStep} />
              )} */}
              {window.innerWidth > 768 ? (
                <VerticalLinearStepper steps={steps} activeStep={activeStep} />
              ) : (
                <HorizontalLinearStepper
                  steps={steps}
                  activeStep={activeStep}
                />
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
            <div className="step-cont-image">{renderSteps()}</div>
          </Grid>
        </Grid>
      </Box>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default ImageConfigurator;
